export class Customer {
  id: number
  businessName: string
  tradename: string
  tin: string
  phone: number
  address: string
  zip: number
  city: string
  province: string
  email: string
  contactName: string
  contactPhone: number
  tax: number
  disabled: boolean

  constructor(props: Customer) {
    Object.assign(this, props)
  }
}

export class CustomerSales extends Customer {
  sales: number
  saleDate: Date
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Customers/Model.ts